const CHECKBOX_INPUT = {
  label: 'Billing info for card is same as shipping info',
  name: 'billingInfoSameAsShipping',
};

const CARD_INPUT_STYLES = {
  invalid: {
    fontColor: '#cc484a',
  },
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: '14px',
  marginTop: '0',
};

const COUNTRIES = [
  {
    name: 'United States',
    value: 'US',
  },
  {
    name: 'Canada',
    value: 'CA',
  },
  {
    name: 'United Kingdom',
    value: 'GB',
  },
];

export { CHECKBOX_INPUT, CARD_INPUT_STYLES, COUNTRIES };
